/**
 * Cadastro rápido de item do catálogo direto no agendamento.
 *
 * Setting por empresa (`role = COMPANY`), editado em Configurações Médicas e
 * lido pela tela de agendamento. Guardado como string ('true'/'false') porque a
 * página de configurações médicas usa a API genérica de `Setting` (campo
 * `value`), não `jsonValue`.
 *
 * Padrão **desligado**: cadastrar item do catálogo no meio do agendamento é um
 * atalho útil para quem opera com catálogo em construção, mas indesejado onde o
 * catálogo é curado — ali um item criado às pressas vira duplicata.
 */
export const CATALOG_QUICK_CREATE_SETTING = 'catalog_quick_create_enabled'

export const DEFAULT_CATALOG_QUICK_CREATE_ENABLED = false

/** Converte o valor cru do Setting em booleano (ausente/inválido = padrão). */
export function normalizeCatalogQuickCreate(
    value: string | null | undefined
): boolean {
    if (value === 'true') return true
    if (value === 'false') return false
    return DEFAULT_CATALOG_QUICK_CREATE_ENABLED
}
